/* eslint-disable react-hooks/exhaustive-deps */
import { useTheme } from "@emotion/react";
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PostService from "../../services/postService";
import Popup from "../../components/popups/popup";
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { returnStringByLang } from "../../utils";
import ViewPostStatusModal from "../../components/modals/postStatus/viewPostStatusModal";

const PostStatuses = () => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const isEn = i18n.language === 'en';
    const tableHeadingStyle = { fontWeight: 'bold', backgroundColor: theme.palette.customGrey.tableHeading, cursor: 'pointer' };

    const [statuses, setStatuses] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState({});
    const [openView, setOpenView] = useState(false);

    const [showPopup, setShowPopup] = useState(false);
    const [popupMsg, setPopupMsg] = useState(false);
    const [popupType, setPopupType] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleOpenView = (branch) => {
        setSelectedStatus(branch);
        setOpenView(true);
    };

    const handleCloseView = () => {
        setOpenView(false);
        fetchData();
    };

    const fetchData = async () => {
        try {
            if (isLoading) return;
            setIsLoading(true);
            const data = await PostService.fetchAllPostStatuses();
            setStatuses(data);

        } catch (error) {
            console.error('Error fetching streets:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <Box sx={{
            p: 2,
            backgroundColor: theme.palette.secondary.main,
        }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <ViewPostStatusModal
                    open={openView}
                    handleClose={handleCloseView}
                    postStatus={selectedStatus}
                    setPopupMsg={setPopupMsg}
                    setPopupType={setPopupType}
                    setShowPopup={setShowPopup}
                />
            </Box>
            {showPopup && (
                <Popup
                    text={popupMsg}
                    type={popupType}
                    onClose={() => setShowPopup(false)}
                />
            )}


            <Box sx={{
                display: 'flex'
            }}>
                {/* Scrollable Table with Sticky Header */}
                <TableContainer
                    component={Paper}
                    sx={{
                        boxShadow: 'none',
                        border: 1,
                        borderColor: theme.palette.customGrey.borderInput,
                        borderRadius: 2,
                        height: 'calc(100vh - 90px)',
                        overflowY: 'auto',
                        width: '100%'
                    }}
                >
                    <Table stickyHeader aria-label="simple table">
                        <TableHead
                            sx={{
                                position: 'sticky',
                                top: 0,
                                zIndex: 1,
                            }}
                        >
                            <TableRow>
                                <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                    {t('id')}
                                </TableCell>

                                <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                    {t('name')}
                                </TableCell>

                                <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                    {t('order')}
                                </TableCell>

                                <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                    {t('sendNotification')}
                                </TableCell>

                                <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                    {t('sendMessage')}
                                </TableCell>

                                <TableCell align={isEn ? 'left' : 'right'} sx={tableHeadingStyle}>
                                    {t('color')}
                                </TableCell>

                                <TableCell align={isEn ? 'left' : 'right'} sx={{ ...tableHeadingStyle, cursor: 'auto' }}>
                                    {t('actions')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {statuses.map((status, index) => (
                                <TableRow
                                    key={status.id} sx={{
                                        '&:last-child td, &:last-child th': { border: 0 },
                                    }}>
                                    <TableCell align={isEn ? 'left' : 'right'} component="th" scope="row">{status.id}</TableCell>
                                    <TableCell align={isEn ? 'left' : 'right'}>{returnStringByLang(status, i18n.language)}</TableCell>
                                    <TableCell align={isEn ? 'left' : 'right'}>{status.order}</TableCell>
                                    <TableCell align={isEn ? 'left' : 'right'}
                                        sx={{
                                            fontWeight: 'bold',
                                            color: status.sendNotification ? theme.palette.green.box : theme.palette.red.box
                                        }}>{status.sendNotification ? t("yes") : t("no")}</TableCell>
                                    <TableCell align={isEn ? 'left' : 'right'}
                                        sx={{
                                            fontWeight: 'bold',
                                            color: status.sendMessage ? theme.palette.green.box : theme.palette.red.box
                                        }}>{status.sendMessage ? t("yes") : t("no")}</TableCell>
                                    <TableCell align={isEn ? 'left' : 'right'}>
                                        <Box sx={{
                                            bgcolor: status.color,
                                            width: '70%',
                                            height: 30,
                                            borderRadius: 1
                                        }}>
                                        </Box>
                                    </TableCell>
                                    <TableCell align={isEn ? 'left' : 'right'}>
                                        <Box sx={{
                                            display: 'inline-flex',
                                            border: 1,
                                            borderColor: theme.palette.customGrey.borderInput,
                                            backgroundColor: theme.palette.secondary.main,
                                            borderRadius: 1,
                                        }}>
                                            <Box sx={{
                                                px: 1.5,
                                                pt: 0.6,
                                                pb: 0.25,
                                                cursor: 'pointer'
                                            }} onClick={() => handleOpenView(status)}>
                                                <RemoveRedEyeOutlinedIcon fontSize='small'
                                                    sx={{ color: theme.palette.text.primary }} />
                                            </Box>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

            </Box>

        </Box>
    );
}

export default PostStatuses;